import React from "react";

export const CatholicDocs = ({size = 20, ...props}) => {
    return (
        <svg
            viewBox="0 0 512 512"
            width={size}
            height={size}
            {...props}
        >
            <path
                d="M46.886 0C20.992 0 0 20.901 0 46.684v35.402h93.772V46.684C93.772 20.901 72.781 0 46.886 0z"
                fill="#f80"
            />
            <path
                d="M418.231 45.602v384.316H187.4v38.933s-4.149 43.148-46.737 43.148-46.895-44.732-46.895-44.732V46.682C93.768 20.898 72.779 0 46.884 0h325.548c25.295 0 45.799 20.416 45.799 45.602z"
                fill="#e0e0e2"
            />
            <path
                d="M418.231 45.602v384.316H258.032V0h114.399c25.296 0 45.8 20.416 45.8 45.602z"
                fill="#d8d8da"
            />
            <path
                d="M512 429.918v37.455C512 492.025 491.938 512 467.19 512H140.663c42.588 0 46.737-43.148 46.737-43.148v-38.933H512z"
                fill="#f80"
            />
            <path
                d="M512 429.918v37.455C512 492.025 491.938 512 467.19 512H258.032v-82.082H512z"
                fill="#ff4f19"
            />
            <path
                fill="#5c1b6f"
                d="M314.68 86.605L314.68 116.475 273.06 116.475 273.06 216.382 243.06 216.382 243.06 116.475 201.44 116.475 201.44 86.605 243.06 86.605 243.06 45.125 273.06 45.125 273.06 86.605z"
            />
            <path fill="#adacb2" d="M163.63 270.348H358.12V300.219H163.63z" />
            <path fill="#adacb2" d="M163.63 339.25H358.12V369.121H163.63z" />
            <path
                fill="#451052"
                d="M273.06 216.382L258.03 216.382 258.03 45.125 273.06 45.125 273.06 86.605 314.68 86.605 314.68 116.475 273.06 116.475z"
            />
            <path fill="#78777f" d="M258.03 270.348H358.12V300.219H258.03z" />
            <path fill="#78777f" d="M258.03 339.25H358.12V369.121H258.03z" />
        </svg>
    );
}